/**
 * Cookie consent interfaces following GDPR best practices
 */

/**
 * Cookie category types
 */
export enum CookieCategory {
  NECESSARY = 'necessary',
  ANALYTICS = 'analytics',
}

/**
 * Cookie consent preferences stored in localStorage
 */
export interface ICookieConsent {
  /** Timestamp when consent was given */
  timestamp: number;
  /** Version of the consent (for tracking policy changes) */
  version: string;
  /** User's cookie preferences by category */
  preferences: ICookiePreferences;
  /** Whether the user has explicitly made a choice */
  hasConsented: boolean;
}

/**
 * User's preferences for each cookie category
 */
export interface ICookiePreferences {
  [CookieCategory.NECESSARY]: boolean; // Always true, cannot be disabled
  [CookieCategory.ANALYTICS]: boolean;
}

/**
 * Metadata about each cookie category
 */
export interface ICookieCategoryInfo {
  key: CookieCategory;
  titleKey: string; // Translation key
  descriptionKey: string; // Translation key
  required: boolean;
  services?: string[]; // List of services using this category
}

/**
 * Event emitted when consent changes
 */
export interface ICookieConsentChangeEvent {
  category: CookieCategory;
  enabled: boolean;
  timestamp: number;
}
